export const ROLE_RANK = {
  CEO: 100, Admin: 100,
  MD: 90,
  GM: 80, "General Manager": 80,
  DM: 70,
  BM: 60, Manager: 60,
  Receptionist: 40, "Front Desk": 40,
  Trainer: 30, "Personal Trainer": 30, Coach: 30, Nutritionist: 30,
  Security: 20,
  Housekeeping: 10,
};

export const ROLE_OPTIONS = ["CEO", "MD", "GM", "DM", "BM", "Receptionist", "Trainer", "Security", "Housekeeping"];

export const ROLE_LABELS = {
  CEO: "CEO", MD: "MD (Managing Director)", GM: "GM (General Manager)",
  DM: "DM (District Manager)", BM: "BM (Branch Manager)",
  Receptionist: "Receptionist", Trainer: "Trainer",
  Security: "Security", Housekeeping: "Housekeeping",
};

export const rank = (role) => ROLE_RANK[role] || 0;
export const canDelete = (role) => rank(role) >= 90;    // CEO, MD
export const canEdit = (role) => rank(role) >= 70;      // DM, GM, MD, CEO
export const canManagePackages = (role) => rank(role) >= 60; // BM+
export const canManageMembers = (role) => rank(role) >= 40;  // Receptionist+
export const seesAllBranches = (role) => rank(role) >= 80;   // GM, MD, CEO
